import React, { useEffect, useState } from "react";
import HearingIcon from '@mui/icons-material/Hearing';
import './App.css';
import './Zero.css';
import images from './image/Pictures';
import { Typography, Button, Grid,Container} from '@mui/material';

function App() {
  const [showAlphabet, setShowAlphabet] = useState(false);
  const [showColors, setShowColors] = useState(false);
  const [showShapes, setShowShapes] = useState(false);
  const [showNumbers, setShowNumbers] = useState(false);
  const [showAnimals, setShowAnimals] = useState(false);
  const [showWeather, setShowWeather] = useState(false);
  const [showBodyParts, setShowBodyParts] = useState(false);
  const [showDaysOfWeek, setShowDaysOfWeek] = useState(false);

  const handleSectionClick = (section) => {
    setShowAlphabet(section === "alphabet");
    setShowColors(section === "colors");
    setShowShapes(section === "shapes");
    setShowNumbers(section === "numbers");
    setShowAnimals(section === "animals");
    setShowWeather(section === "weather");
    setShowBodyParts(section === "bodyParts");
    setShowDaysOfWeek(section === "daysOfWeek");
  };
  const playAudio = (audioSrc) => {
    const audio = new Audio(audioSrc);
    audio.playbackRate = 0.8; // Set the playback rate to 0.7
    audio.play();
  };
  const renderAlphabet = () => {
    const alphabet = {};
    for (let char of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ') alphabet[char] = require(`./mp3/Alphabet/${char}.mp3`);
    const capitalLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const smallLetters = 'abcdefghijklmnopqrstuvwxyz';
    const capitalArray = capitalLetters.split('');
    const smallArray = smallLetters.split('');
    const letters = [];
  
    for (let i = 0; i < capitalArray.length; i++) {
      const letter = capitalArray[i];
      const smallLetter = smallArray[i];
      letters.push(
        <Grid key={i} item style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}>
          <Button color="inherit" onClick={() => playAudio(alphabet[letter])} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" align="center" gutterBottom style={{ margin: '5px' }}>
                {letter}
              </Typography>
              <Typography variant="body1" align="center" gutterBottom style={{ margin: '5px' }}>
                {smallLetter}
              </Typography>
            </div>
            <HearingIcon style={{ cursor: 'pointer' }} fontSize="small" />
          </Button>
        </Grid>
      );
    }
    return <Grid container justifyContent="center" spacing={2}>{letters}</Grid>;
};

  
  const colorData = [
    { code: "#ff0000", name: "Red",displayName: "Red"  },
    { code: "#0000ff", name: "Blue" ,displayName:"Blue" },
    { code: "#ffff00", name: "Yellow" ,displayName:"Yellow" },
    { code: "#FFA500", name: "Orange" ,displayName:"Orange" },
    { code: "#008000", name: "Green" ,displayName:"Green" },
    { code: "#800080", name: "Violet" ,displayName: "Violet"},
    { code: "#FF4500", name: "RedOrange",displayName: "Red Orange"  },
    { code: "#ffae42", name: "YellowOrange",displayName:"Yellow Orange"  },
    { code: "#ADFF2F", name: "YellowGreen",displayName:"Yellow Green"  },
    { code: "#7BCCB5", name: "BlueGreen",displayName:"Blue Green"  },
    { code: "#8A2BE2", name: "BlueViolet",displayName:"Blue Violet"  },
    { code: "#922b3e", name: "RedViolet",displayName:"Red Violet"  },
    { code: "#FFFFFF", name: "White",displayName:"White"  },
    { code: "#000000", name: "Black",displayName:"Black"  },
    { code: "#FFC0CB", name: "Pink",displayName:"Pink"  },
    { code: "#87CEEB", name: "SkyBlue",displayName:"Sky Blue"  },
    { code: "#FFD700", name: "Gold",displayName:"Gold"  },
    { code: "#A52A2A", name: "Brown",displayName:"Brown"  },
    { code: "#800000", name: "Maroon",displayName:"Maroon"  },
    { code: "#808080", name: "Gray",displayName:"Gray"  },
 
  ];
  const renderColors = () => {
    const colorAudioSources = {};
    colorData.forEach((color) => {
      colorAudioSources[color.name] = require(`./mp3/Colors/${color.name}.mp3`);
    });
  
    return (
      <Grid container spacing={2}>
        {colorData.map((color, index) => (
          <Grid
            key={index}
            item
            xs={3}
            sm={6}
            md={4}
            lg={3}
            xl={2}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '10px',
            }}
          >
            <Button onClick={() => playAudio(colorAudioSources[color.name])} style={{ cursor: 'pointer' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: '5px',
                }}
              >
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: color.code,
                    border: '2px solid black',
                    margin: '5px',
                  }}
                ></div>
                <Typography variant="body1" align="center" gutterBottom style={{ margin: '5px', color: 'black' }}>
                  {color.displayName}
                </Typography>
              </div>
            </Button>
          </Grid>
        ))}
      </Grid>
    );
  };
  
  const renderShapes = () => {
    const shapes = [
      { name: 'Square', image: images.Square },
      { name: 'Circle', image: images.Circle },
      { name: 'Triangle', image: images.Triangle },
      { name: 'Pentagon', image: images.Pentagon },
      { name: 'Hexagon', image: images.Hexagon },
      { name: 'Octagon', image: images.Octagon },
      { name: 'Rectangle', image: images.Rectangle },
      { name: 'Oval', image: images.Oval },
      { name: 'Diamond', image: images.Diamond },
      { name: 'Star', image: images.Star },
    ];
  
    const Shapess = {};
    shapes.forEach((shape) => (Shapess[shape.name] = require(`./mp3/Shapes/${shape.name}.mp3`)));
  
    return (
      <Grid container spacing={2}>
        {shapes.map((shape, index) => (
          <Grid
            key={index}
            item
            xs={5}
            sm={6}
            md={4}
            lg={3}
            xl={2}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}
          >
            <Button onClick={() => playAudio(Shapess[shape.name])} style={{ cursor: 'pointer' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src={shape.image} alt={shape.name} style={{ width: '100px', height: '100px' }} />
                <Typography
                  variant="body1"
                  align="center"
                  gutterBottom
                  style={{ margin: '5px', color: 'black' }}
                >
                  {shape.name}
                </Typography>
              </div>
            </Button>
          </Grid>
        ))}
      </Grid>
    );
  };
  

  const renderNumbers = () => {
    const numbersArray = Array.from({ length: 100 }, (_, i) => i + 1);
    const numberss = {};
  
    // Preload all the audio files
    for (let i = 1; i <= 100; i++) {
      numberss[i.toString()] = require(`./mp3/Numbers/${i}.mp3`);
    }
  
    return (
      <Grid container spacing={2}>
        {numbersArray.map((number, index) => (
          <Grid key={index} item xs={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}>
            <Button onClick={() => playAudio(numberss[number.toString()])} style={{ cursor: "pointer", color: "black" }}>
              {number}
            </Button>
          </Grid>
        ))}
      </Grid>
    );
  };
  
const renderAnimals = () => {
  const animals = [
    { name: 'Monkey', image: images.Monkey },
    { name: 'Giraffe', image: images.Giraffe },
    { name: 'Bear', image: images.Bear },
    { name: 'Deer', image: images.Deer },
    { name: 'Dog', image: images.Dog },
    { name: 'Cat', image: images.Cat },
    { name: 'Duck', image: images.Duck },
    { name: 'Chicken', image: images.Chicken },
    { name: 'Goat', image: images.Goat },
    { name: 'Horse', image: images.Horse },
    { name: 'Frog', image: images.Frog },
    { name: 'Cow', image: images.Cow },
    { name: 'Pig', image: images.Pig },
    { name: 'Mouse', image: images.Mouse },
  ];

  const animalss = {};
  animals.forEach((animal) => (animalss[animal.name] = require(`./mp3/Animals/${animal.name}.mp3`)));

  return (
    <Grid container justifyContent="center" spacing={5}>
      {animals.map((animal, index) => (
        <Grid key={index} item xs={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}>
          <Button onClick={() => playAudio(animalss[animal.name])} style={{ cursor: 'pointer' }}>
            <img src={animal.image} alt={animal.name} style={{ width: '100px', height: '100px' }} />
          </Button>
          <Typography variant="body1" align="center" gutterBottom style={{ margin: '5px', color: 'black' }}>
            {animal.name}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};         
const renderWeather = () => {
  const weatherConditions = [
    { condition: 'Sunny', image: images.Sunny },
    { condition: 'Rainy', image: images.Rainy },
    { condition: 'Windy', image: images.Windy },
    { condition: 'Snowy', image: images.Snowy },
    { condition: 'Cloudy', image: images.Cloudy },
  ];
  const weathers = {};
  weatherConditions.forEach((weather) => (weathers[weather.condition] = require(`./mp3/Weather/${weather.condition}.mp3`)));

  return (
    <Grid container justifyContent="center" spacing={2}>
      {weatherConditions.map((weather, index) => (
        <Grid key={index} item>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Button onClick={() => playAudio(weathers[weather.condition])} style={{ cursor: 'pointer' }}>
              <div>
                <img src={weather.image} alt={weather.condition} style={{ width: '300px', height: '200px' }} />
                <Typography variant="body1" align="center" gutterBottom style={{ color: 'black' }}>
                  {weather.condition}
                </Typography>
              </div>
            </Button>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

const bodyPartsData = [
  { name: 'Head', image: images.Head },
  { name: 'Shoulder', image: images.Shoulder },
  { name: 'Knees', image: images.Knees },
  { name: 'Toes', image: images.Toes },
  { name: 'Eyes', image: images.Eyes },
  { name: 'Ears', image: images.Ears },
  { name: 'Mouth', image: images.Mouth },
  { name: 'Nose', image: images.Nose },
];

const body = {};
bodyPartsData.forEach((part) => {
  body[part.name] = require(`./mp3/BodyParts/${part.name}.mp3`);
});

const renderBodyParts = () => {
  return (
    <Grid container justifyContent="center" spacing={2}>
      {bodyPartsData.map((part, index) => (
        <Grid
          key={index}
          item
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}
        >
          <Button onClick={() => playAudio(body[part.name])} style={{ cursor: 'pointer' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={part.image} alt={part.name} style={{ width: '150px', height: '140px' }} />
              <Typography variant="body1" align="center" gutterBottom style={{ margin: '5px', color: 'black' }}>
                {part.name}
              </Typography>
            </div>
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

const daysOfWeekData = [
  { name: 'Sunday', image: images.Sunday },
  { name: 'Monday', image: images.Monday },
  { name: 'Tuesday', image: images.Tuesday },
  { name: 'Wednesday', image: images.Wednesday },
  { name: 'Thursday', image: images.Thursday },
  { name: 'Friday', image: images.Friday },
  { name: 'Saturday', image: images.Saturday },
];

const days = {};
daysOfWeekData.forEach((day) => {
  days[day.name] = require(`./mp3/day/${day.name}.mp3`);
});

const renderDaysOfWeek = () => {
  return (
    <Grid container justifyContent="center" spacing={2}>
      {daysOfWeekData.map((day, index) => (
        <Grid
          key={index}
          item
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}
        >
          <Button onClick={() => playAudio(days[day.name])} style={{ cursor: 'pointer' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={day.image} alt={day.name} style={{ width: '250px', height: '150px' }} />
              <Typography variant="body1" align="center" gutterBottom style={{ margin: '5px', color: 'black' }}>
             
              </Typography>
            </div>
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};




const ChatHeader = ({ handleSectionClick }) => {
  useEffect(() => {
    document.title = "Zero Level";
  }, []);

  return (
    <div>
      <Typography variant="h4" align="center" gutterBottom>
        Zero Level
      </Typography>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item>
          <Button onClick={() => handleSectionClick('alphabet')} color="inherit">
            Alphabet
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleSectionClick('colors')} color="inherit">
            Colors
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleSectionClick('shapes')} color="inherit">
            Shapes
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleSectionClick('numbers')} color="inherit">
            Numbers
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleSectionClick('animals')} color="inherit">
            Animals
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleSectionClick('weather')} color="inherit">
            Weather
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleSectionClick('bodyParts')} color="inherit">
            Body Parts
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleSectionClick('daysOfWeek')} color="inherit">
            Days of Week
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
return (
  <div className="App">
    <div className="backgroundImage"></div>
    <Container maxWidth="md" sx={{ pt: 2 }}>
      <ChatHeader handleSectionClick={handleSectionClick} />
      {showAlphabet && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderAlphabet()}
        </Container>
      )}
      {showColors && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderColors()}
        </Container>
      )}
      {showShapes && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderShapes()}
        </Container>
      )}
      {showNumbers && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderNumbers()}
        </Container>
      )}
      {showAnimals && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderAnimals()}
        </Container>
      )}
      {showWeather && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderWeather()}
        </Container>
      )}
      {showBodyParts && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderBodyParts()}
        </Container>
      )}
      {showDaysOfWeek && (
        <Container maxWidth="md" sx={{ pt: 2 }}>
          {renderDaysOfWeek()}
        </Container>
      )}
    </Container>
  </div>
);
}


export default App;
